import { DevelopmentHistoryDTO, DevelopmentHistoryFlatDTO } from "../domain/models/dto/DevelopmentHistoryDTO";
import { DevelopmentHistoryFlatCollection, IDevelopmentHistoryFlat } from "../domain/models/DevelopmentHistory";
import { DevelopmentHistoryService } from "../domain/services/DevelopmentHistoryService";
import { DevelopmentHistoryFlatMapper } from "../mappers/DevelopmentHistoryFlatMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { LanguageServiceImpl } from "./LanguageServiceImpl";

export class DevelopmentHistoryServiceImpl extends BaseServiceImpl implements DevelopmentHistoryService {
    static _instance: DevelopmentHistoryService;
    private readonly developmentHistoryEndpoint = "/api/v1/development-history";

    private constructor() {
        super();
    }

    static getInstance(): DevelopmentHistoryService {
        if (!DevelopmentHistoryServiceImpl._instance) {
            DevelopmentHistoryServiceImpl._instance = new DevelopmentHistoryServiceImpl();
        }
        return DevelopmentHistoryServiceImpl._instance;
    }

    async getAllDevelopmentHistory(
        currentPage: number,
        currentLimit: number,
        filtersDTO: DevelopmentHistoryDTO = {} as DevelopmentHistoryDTO
    ): Promise<DevelopmentHistoryFlatCollection> {
        try {
            let url = `${this.developmentHistoryEndpoint}?page=${currentPage}&limit=${currentLimit}&lang=${LanguageServiceImpl.getInstance().currentLang}&getEntityTranslations=false`;

            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            const result = await this.get<DevelopmentHistoryFlatCollection>(url);

            return {
                ...result,
                rows: result.rows.map((dto: DevelopmentHistoryFlatDTO) =>
                    new DevelopmentHistoryFlatMapper().fromDTO(dto)
                ),
            };
        } catch (err) {
            console.log("Error in DevelopmentHistoryServiceImpl.getAllDevelopmentHistory");
            console.log(err);
            throw err;
        }
    }

    async getDevelopmentHistoryById(id: string): Promise<IDevelopmentHistoryFlat | null> {
        try {
            if (!id) return null;

            const dto = await this.get<DevelopmentHistoryFlatDTO>(
                `${this.developmentHistoryEndpoint}/${id}?lang=${LanguageServiceImpl.getInstance().currentLang}`
            );
            return new DevelopmentHistoryFlatMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in DevelopmentHistoryServiceImpl.getDevelopmentHistoryById");
            console.log(err);
            return null;
        }
    }
}

export function developmentHistoryServiceFactory(): DevelopmentHistoryService {
    return DevelopmentHistoryServiceImpl.getInstance();
}
